import {
  mainnetNetworks,
  protocolForNetwork,
  networkDisplayName,
} from "./chain-protocol-registry.js";
// The Mainframe protocol registry owns network identity and precision. No addresses or keys are bundled.
export const CRYPTO_ASSETS = mainnetNetworks.map((network) => {
  const protocol = protocolForNetwork(network);
  return {
    id: network,
    network,
    currency: protocol.nativeAsset.code,
    decimals: protocol.nativeAsset.decimals,
    label: `${protocol.nativeAsset.code} · ${networkDisplayName(network)}`,
  };
});
export function cryptoAsset(id: string) {
  const asset = CRYPTO_ASSETS.find((a) => a.id === id);
  if (!asset) throw new Error("Unsupported crypto network.");
  return asset;
}
